import { limitLength } from '@hotjar/insights-common/lib/string';

export const truncateUrl = (url: string): string => (url ? limitLength(url, 30, '⋯') : url);
